(() => {
  const SELECTOR = '[data-noa-lightbox]';
  let lastTrigger = null;

  function buildDialog() {
    const dialog = document.createElement('dialog');
    dialog.className = 'noa-lightbox';
    dialog.innerHTML =
      '<div class="noa-lightbox__panel">' +
      '<button class="noa-lightbox__close" type="button"><span aria-hidden="true">&times;</span></button>' +
      '<img class="noa-lightbox__image" alt="">' +
      '<p class="noa-lightbox__caption"></p>' +
      '</div>';

    const closeButton = dialog.querySelector('.noa-lightbox__close');

    const close = () => dialog.close();
    closeButton.addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('noa-lightbox-open');
      if (lastTrigger instanceof HTMLElement) lastTrigger.focus();
    });

    document.body.appendChild(dialog);
    return dialog;
  }

  function enhanceContentImages() {
    document.querySelectorAll('[data-noa-lightbox-gallery="true"]').forEach((gallery) => {
      const openLabel = gallery.dataset.noaLightboxOpenLabel || '';
      const closeLabel = gallery.dataset.noaLightboxCloseLabel || '';

      gallery.querySelectorAll('figure img:not([data-noa-lightbox-ignore])').forEach((image) => {
        if (image.closest('a') || image.hasAttribute('data-noa-lightbox-ready')) return;

        image.setAttribute('data-noa-lightbox-ready', 'true');
        image.setAttribute('tabindex', '0');
        image.setAttribute('role', 'button');
        image.setAttribute('data-noa-lightbox', '');
        image.setAttribute('data-noa-lightbox-src', image.currentSrc || image.src);
        image.setAttribute('data-noa-lightbox-alt', image.alt || '');
        image.setAttribute('data-noa-lightbox-caption', image.alt || '');
        image.setAttribute('data-noa-lightbox-close-label', closeLabel);
        image.setAttribute('aria-label', [openLabel, image.alt].filter(Boolean).join(': '));
      });
    });
  }

  function openLightbox(trigger) {
    const source = trigger.dataset.noaLightboxSrc || trigger.getAttribute('href');
    if (!source) return;

    const dialog = document.querySelector('.noa-lightbox') || buildDialog();
    const image = dialog.querySelector('.noa-lightbox__image');
    const caption = dialog.querySelector('.noa-lightbox__caption');
    const closeButton = dialog.querySelector('.noa-lightbox__close');

    image.src = source;
    image.alt = trigger.dataset.noaLightboxAlt || '';
    caption.textContent = trigger.dataset.noaLightboxCaption || '';
    closeButton.setAttribute('aria-label', trigger.dataset.noaLightboxCloseLabel || '');
    lastTrigger = trigger;

    document.body.classList.add('noa-lightbox-open');
    dialog.showModal();
    closeButton.focus();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(SELECTOR);
    if (!trigger) return;
    event.preventDefault();
    openLightbox(trigger);
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest(SELECTOR);
    if (!trigger || trigger.tagName === 'A') return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    openLightbox(trigger);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceContentImages);
  } else {
    enhanceContentImages();
  }

  document.addEventListener('shopify:section:load', enhanceContentImages);
})();
